const React = require('react');
const { parseRequestBodyProperties, getNested } = require('../app/components/APIReference/parser');

const { createContext, useContext, useState } = React;

const apiRefContext = createContext();

const ApiRefContextProvider = (props) => {
  const {
    children,
    lang,
    i18n,
    platform,
    paths,
    appCredentials,
    apiRefLiveTestingEnabled,
    initialResponseContent,
    postmanCollectionUrl
  } = props;

  const apiEndpoint = paths ? Object.keys(paths)[0] : null;
  const apiMethod = apiEndpoint ? Object.keys(paths[apiEndpoint])[0] : null;
  const apiData = apiEndpoint ? paths[apiEndpoint][apiMethod] : null;

  const [actualParams, setActualParams] = useState({
    apiEndpoint,
    apiMethod,
    apiData,
  });

  const getRequestParameters = (newApiData, shouldAddPlaceholder = false) => {
    const bodyProperties = getNested(
      newApiData,
      'requestBody.content.application/json.schema',
    ) || {};
    let requestParameters = newApiData?.parameters ? newApiData?.parameters : [];
    if (shouldAddPlaceholder) {
      requestParameters.forEach((reqItem) => {
        if (reqItem?.example === undefined) {
          reqItem.example = reqItem?.schema?.example;
        }
      });
    }

    const bodyParsedProperties = parseRequestBodyProperties(
      bodyProperties.properties,
    );

    requestParameters = requestParameters.concat(bodyParsedProperties);

    if (requestParameters.length <= 0) {
      requestParameters.push({
        description: {
          es: 'No es necesario utilizar ningún parámetro para realizar la solicitud.',
          pt: 'Não é necessário usar nenhum parâmetro para fazer a requisição.',
          en: 'You dont need to use any parameters to make the request.',
        },
        type: ' ',
        in: ' ',
      });
    }
    return requestParameters;
  };

  const updateActualPageData = (newBaseData) => {
    const newApiEndpoint = newBaseData ? Object.keys(newBaseData)[0] : null;
    const newApiMethod = newApiEndpoint ? Object.keys(newBaseData[newApiEndpoint])[0] : null;
    const newApiData = newApiEndpoint ? newBaseData[newApiEndpoint][newApiMethod] : null;

    setActualParams({
      apiEndpoint: newApiEndpoint,
      apiMethod: newApiMethod,
      apiData: newApiData,
    });
  };
  const requestParameters = getRequestParameters(apiData, true);
  const [requestParamsData, setRequestParamsData] = useState(requestParameters);
  const [responseDataContent, setResponseDataContent] = useState(initialResponseContent);

  return (
    <div>
      <apiRefContext.Provider value={{
        lang,
        i18n,
        platform,
        actualParams,
        appCredentials,
        requestParameters,
        setActualParams,
        requestParamsData,
        setRequestParamsData,
        responseDataContent,
        setResponseDataContent,
        updateActualPageData,
        getRequestParameters,
        apiRefLiveTestingEnabled,
        postmanCollectionUrl,
      }}
      >
        {children}
      </apiRefContext.Provider>
    </div>
  );
};

const useApiRefContextProvider = () => {
  const context = useContext(apiRefContext);
  return {
    ...context,
  };
};

module.exports = { useApiRefContextProvider, ApiRefContextProvider };
